var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 110,
    height: 110,
    rx: 25,
    fill: "#EDEFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 35             C43 35, 40 37, 40 40             C40 65, 55 80, 80 80             C83 80, 85 77, 85 75             L85 70             C85 68, 83 66, 81 66             L73 66             C71 66, 69 67, 68 69             L66 72             C58 68, 52 62, 48 54             L51 52             C53 51, 54 49, 54 47             L54 39             C54 37, 52 35, 50 35             Z",
    fill: "none",
    stroke: "#1E3A8A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.12d9ffb58b41b110ce2837cbe820d2dd.svg";
export { ForwardRef as ReactComponent };